import { encodePaginatableQuery, PaginatableQuery, Query } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface CourseQuery extends PaginatableQuery {
  search: string;
}

export const encodeCourseQuery = (query: CourseQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
});
